import type { ReactElement, ReactNode } from 'react';
import React from 'react';
import type {
  TextStyle,
  Text as RNText,
  TextProps as RNTextProps,
} from 'react-native';

import { DEFAULT_FONT_FAMILY, WEIGHT_MAP } from '@garnish/constants';

import { BaseText } from '../BaseText';

export type TextProps = {
  readonly family?: string;
  readonly bold?: boolean;
  readonly underline?: boolean;
  readonly children: ReactNode;
} & RNTextProps;

export const Text = React.forwardRef(
  (props: TextProps, ref: React.Ref<RNText>): ReactElement<RNText> => {
    const {
      family = DEFAULT_FONT_FAMILY,
      bold = false,
      underline = false,
      style,
      children,
      ...rest
    } = props;

    const textStyles: TextStyle = {
      fontWeight: bold ? WEIGHT_MAP.bold : WEIGHT_MAP.normal,
      textDecorationLine: underline ? 'underline' : 'none',
      fontFamily: family,
    };

    return (
      <BaseText ref={ref} style={[textStyles, style]} {...rest}>
        {children}
      </BaseText>
    );
  },
);
